import { useMemo } from 'react'
import { nanoid } from 'nanoid'

export const useId = (id?: string): string => {
  return useMemo(() => {
    return id || nanoid()
  }, [id])
}
